import React from "react";

export const TimeIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.477"
      height="24"
      viewBox="0 0 24.477 24"
    >
      <path
        data-name="Path 2192"
        d="M27.238,15A12.137,12.137,0,0,0,15,27a12.241,12.241,0,0,0,24.477,0A12.137,12.137,0,0,0,27.238,15Zm0,2.057A9.945,9.945,0,1,1,17.1,27,10.027,10.027,0,0,1,27.238,17.057Zm0,1.714A1.039,1.039,0,0,0,26.189,19.8V27a1.017,1.017,0,0,0,.306.729l4.7,4.607a1.067,1.067,0,0,0,1.486,0,1.018,1.018,0,0,0,0-1.457l-4.393-4.307V19.8A1.039,1.039,0,0,0,27.238,18.771Z"
        transform="translate(-15 -15)"
      />
    </svg>
  );
};
